/**
 * Gallery Images reducer.
 * @module reducers/content_types/pages
 */

import { map } from 'lodash';
//  import { settings } from '~/config';

 import { GET_CONTENT_METADATA } from '../../constants/ActionTypes';

 const initialState = {
   error: null,
   loaded: false,
   loading: true,
   metadata: []
 };

 /**
  * Faq reducer.
  * @function metadata
  * @param {Object} state Current state.
  * @param {Object} action Action to be handled.
  * @returns {Object} New state.
  */
 export default function metadata(state = initialState, action = {}) {
   switch (action.type) {
     case `${GET_CONTENT_METADATA}_PENDING`:
       return {
         ...state,
         error: "LOADING METADATA",
         loading: true,
         loaded: false,
         metadata: [],
       };
     case `${GET_CONTENT_METADATA}_SUCCESS`:
       const results = action.result.items;
    //    console.log(`>>>>>>>>>>>>>>> GET_CONTENT_METADATA_SUCCESS:`, results);
    //    console.log(`>>>>>>>>>>>>>>> ACTION:`, action);
       return {
         ...state,
          error: "DATA RECEIVED SUCCESSFULLY",
          loaded: true,
          loading: false,
          metadata: results
       };

     case `${GET_CONTENT_METADATA}_FAIL`:
    //    console.log(">>>>>>>>>>>>>>> GET_CONTENT_METADATA_FAIL");
       return {
         ...state,
         error: action.error,
         loading: false,
         loaded: false,
         metadata: [],
       };
     default:
       return state;
   }
 }